module.exports = __webpack_public_path__ + "images/embed/icons/arrow_right.png";